// extracted by mini-css-extract-plugin
module.exports = {"wishlist":"WishlistButton_wishlist__3swOK","badge":"WishlistButton_badge__2y3fq"};